import React, { useRef } from 'react'
import { states } from 'utils'

const StateSelectField = ({
  displayErrorForNonUS = false,
  nonStatesErrorMessage = 'Not available in your area',
  onChange,
  ...props
}) => {
  const selectEl = useRef()
  return (
    <>
      <div className='dropdown'>
        <select {...props} ref={selectEl} onChange={() => onChange(selectEl?.current?.value)}>
          <option value='' disabled selected>
            Choose a State
          </option>
          {Object.keys(states).map((abbreviation) => (
            <option key={abbreviation} value={abbreviation}>
              {states[abbreviation]}
            </option>
          ))}
          <option value='non-us'>Not in the USA</option>
        </select>
      </div>
      {displayErrorForNonUS && selectEl?.current?.value === 'non-us' && (
        <p className='field__error'>{nonStatesErrorMessage}</p>
      )}
      <style jsx>{`
        .dropdown {
          position: relative;
        }
        .dropdown:after {
          background-image: url('/static/images/sportsbook/chevron.svg');
          background-size: 16px 16px;
          content: '   ';
          font: 17px 'Helvetica Neue';
          height: 16px;
          width: 16px;
          color: #757575;
          right: 11px;
          top: 14px;
          padding: 0 0 2px;
          position: absolute;
          pointer-events: none;
        }
      `}</style>
    </>
  )
}

export default StateSelectField
